(function (angular) {
    'use strict';

    angular.module('shared')
        /**
         *
         */
        .controller('ThankYouCtrl', ['$scope', '$state', '$location', '$stateParams', 'jwtService', 'growlService',
            function ($scope, $state, $location, $stateParams, jwtService, growlService) {

                $scope.login = function () {
                    jwtService.login($stateParams.user, $stateParams.pass)
                        .then(function (result) {
                            if ($stateParams.link && $stateParams.link != '/login') $location.path($stateParams.link);
                            else $location.path("/home");
                        })
                        .catch(function (error) {
                            $state.go('login', { user: $stateParams.user });
                            console.error("login errored", error);
                        });

                };

            }]);

})(window.angular);